//# sourceMappingURL=capacity.mjs.map
/// <reference types="./capacity.d.mts" />
import * as $ai_config from "../../../../data_types/data/ai_config.mjs";
import * as $llm_capacity from "../../../../data_types/data/llm_capacity.mjs";
import * as $remote from "../../../../data_types/data/remote.mjs";
import * as $colors from "../../../../ds/ds/colors.mjs";
import * as $button from "../../../../ds/ds/components/button.mjs";
import * as $callout from "../../../../ds/ds/components/callout.mjs";
import * as $input from "../../../../ds/ds/components/input.mjs";
import * as $label from "../../../../ds/ds/components/label.mjs";
import * as $l from "../../../../ds/ds/components/layout.mjs";
import * as $loader from "../../../../ds/ds/components/loader.mjs";
import * as $segmented_button from "../../../../ds/ds/components/segmented_button.mjs";
import * as $table from "../../../../ds/ds/components/table.mjs";
import * as $typography from "../../../../ds/ds/components/typography.mjs";
import * as $dict from "../../../../gleam_stdlib/gleam/dict.mjs";
import * as $float from "../../../../gleam_stdlib/gleam/float.mjs";
import * as $int from "../../../../gleam_stdlib/gleam/int.mjs";
import * as $list from "../../../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../../../gleam_stdlib/gleam/option.mjs";
import * as $order from "../../../../gleam_stdlib/gleam/order.mjs";
import * as $result from "../../../../gleam_stdlib/gleam/result.mjs";
import * as $string from "../../../../gleam_stdlib/gleam/string.mjs";
import * as $redraw from "../../../../redraw/redraw.mjs";
import * as $a from "../../../../redraw_dom/redraw/dom/attribute.mjs";
import * as $e from "../../../../redraw_dom/redraw/dom/events.mjs";
import * as $h from "../../../../redraw_dom/redraw/dom/html.mjs";
import * as $css from "../../../../sketch/sketch/css.mjs";
import * as $length from "../../../../sketch/sketch/css/length.mjs";
import { px } from "../../../../sketch/sketch/css/length.mjs";
import * as $capacity from "../../../admin/capacity.mjs";
import { Scenario } from "../../../admin/capacity.mjs";
import * as $llm_capacity_effects from "../../../admin/effects/llm_capacity.mjs";
import * as $store from "../../../data/store.mjs";
import { Ok, toList, divideFloat, isEqual } from "../../../gleam.mjs";
import * as $rate_limits from "../../../view/administration/llm_capacity/rate_limits.mjs";

const windows_days = /* @__PURE__ */ toList([7, 30]);

const default_scenario = /* @__PURE__ */ new Scenario(4, 4, 6, 2, 0, 0.0);

function model_name(model_alias) {
  return $option.unwrap(model_alias, "No model recorded");
}

function status_label(status) {
  let _block;
  if (status instanceof $capacity.WithinLimits) {
    _block = ["Within limits", $label.success()];
  } else if (status instanceof $capacity.Watch) {
    _block = ["Watch", $label.current()];
  } else if (status instanceof $capacity.NearLimit) {
    _block = ["Near limit", $label.error()];
  } else {
    _block = ["Limits unknown", $label.neutral()];
  }
  let $ = _block;
  let title = $[0];
  let status$1 = $[1];
  return $label.label(
    toList([status$1, $label.capitalize(false), $label.content(title)]),
  );
}

function bound_by(load) {
  let requests = $option.unwrap(load.requests_pct, 0.0);
  let tokens = $option.unwrap(load.tokens_pct, 0.0);
  let $ = requests >= tokens;
  let $1 = load.input_tokens_pct;
  let $2 = load.output_tokens_pct;
  if ($) {
    return "requests";
  } else if ($1 instanceof Some && $2 instanceof Some) {
    let input = $1[0];
    let output = $2[0];
    if (input >= output) {
      return "input tokens";
    } else {
      return "output tokens";
    }
  } else {
    return "tokens";
  }
}

function pct_text(pct) {
  return $float.to_string($float.to_precision(pct, 1)) + "%";
}

function two_lines(first, second) {
  return $l.column(
    toList([$l.gap(2)]),
    toList([]),
    toList([
      $typography.text($typography.sm, $typography.regular, first),
      $typography.text($typography.xs, $typography.regular, second),
    ]),
  );
}

function headroom(load) {
  let $ = $capacity.peak_pct(load);
  if ($ instanceof Some) {
    let peak = $[0];
    return two_lines(
      pct_text(100.0 - peak) + " left",
      "Bound by " + bound_by(load),
    );
  } else {
    return two_lines("–", "");
  }
}

function tokens_limit(load) {
  let $ = load.limits.itpm;
  let $1 = load.limits.otpm;
  if ($ instanceof Some && $1 instanceof Some) {
    let input = $[0];
    let output = $1[0];
    return new Some(input + output);
  } else {
    return load.limits.tpm;
  }
}

function usage(used, limit, pct, limits_read) {
  let used$1 = $rate_limits.thousands($float.round(used));
  if (limit instanceof Some && pct instanceof Some) {
    let limit$1 = limit[0];
    let pct$1 = pct[0];
    return two_lines(
      (used$1 + " / ") + $rate_limits.thousands(limit$1),
      pct_text(pct$1),
    );
  } else {
    return two_lines(
      used$1,
      (() => {
        if (limits_read) {
          return "No limit read";
        } else {
          return "Limits not sent or not refreshed";
        }
      })(),
    );
  }
}

function steps_text(steps) {
  let $ = $list.length(steps) > 3;
  if ($) {
    return (($string.join($list.take(steps, 3), ", ") + " and ") + $int.to_string(
      $list.length(steps) - 3,
    )) + " more";
  } else {
    return $string.join(steps, ", ");
  }
}

function plural(count, word) {
  return (($int.to_string(count) + " ") + word) + (() => {
    if (count === 1) {
      return "";
    } else {
      return "s";
    }
  })();
}

function model_caption(load) {
  let _block;
  let _pipe = $option.to_result(load.model_alias, undefined);
  let _pipe$1 = $result.try$(_pipe, $ai_config.model_from_string);
  let _pipe$2 = $result.map(_pipe$1, $ai_config.provider_name);
  _block = $result.unwrap(_pipe$2, "Unknown model");
  let provider = _block;
  return (provider + " · ") + plural(load.deployments, "deployment");
}

function models_table(loads, deployments) {
  return $table.table(
    toList([]),
    toList([
      $table.headers(
        toList([
          (() => {
            let _pipe = $table.header("Model");
            return $table.fraction(_pipe, 2);
          })(),
          (() => {
            let _pipe = $table.header("Steps");
            return $table.fraction(_pipe, 2);
          })(),
          (() => {
            let _pipe = $table.header("Requests / min");
            return $table.fraction(_pipe, 2);
          })(),
          (() => {
            let _pipe = $table.header("Tokens / min");
            return $table.fraction(_pipe, 2);
          })(),
          (() => {
            let _pipe = $table.header("Headroom");
            return $table.fraction(_pipe, 1);
          })(),
          (() => {
            let _pipe = $table.header("Status");
            return $table.fit(_pipe);
          })(),
        ]),
      ),
      $table.body(
        $list.map(
          loads,
          (load) => {
            let limits_read = $list.any(
              deployments,
              (deployment) => {
                return (isEqual(
                  new Some(deployment.model_alias),
                  load.model_alias
                )) && (deployment.status instanceof $llm_capacity.Read);
              },
            );
            let _pipe = $table.row(
              toList([
                $table.cell(
                  two_lines(model_name(load.model_alias), model_caption(load)),
                ),
                $table.cell(two_lines(steps_text(load.steps), "")),
                $table.cell(
                  usage(
                    load.requests_per_minute,
                    load.limits.rpm,
                    load.requests_pct,
                    limits_read,
                  ),
                ),
                $table.cell(
                  usage(
                    load.input_tokens_per_minute + load.output_tokens_per_minute,
                    tokens_limit(load),
                    load.tokens_pct,
                    limits_read,
                  ),
                ),
                $table.cell(headroom(load)),
                $table.cell(status_label(load.status)),
              ]),
            );
            return $table.row_id(_pipe, model_name(load.model_alias));
          },
        ),
      ),
    ]),
  );
}

function duration_text(seconds) {
  let seconds$1 = $float.round(seconds);
  let $ = seconds$1 < 60;
  let $1 = seconds$1 < 3600;
  if ($) {
    return $int.to_string(seconds$1) + " s";
  } else if ($1) {
    return (($int.to_string(globalThis.Math.trunc(seconds$1 / 60)) + " min ") + $int.to_string(
      seconds$1 % 60,
    )) + " s";
  } else {
    return (($int.to_string(globalThis.Math.trunc(seconds$1 / 3600)) + " h ") + $int.to_string(
      globalThis.Math.trunc(((seconds$1 % 3600)) / 60),
    )) + " min";
  }
}

function card(title, value, caption) {
  return $l.column(
    toList([
      $l.gap(4),
      $l.padding(16),
      $l.styles(
        toList([
          $css.min_width(px(240)),
          $css.border("1px solid " + $colors.light.grey_200),
          $css.border_radius(px(12)),
        ]),
      ),
    ]),
    toList([]),
    toList([
      $typography.text($typography.xs, $typography.medium, title),
      $typography.text($typography.lg, $typography.medium, value),
      $typography.text($typography.xs, $typography.regular, caption),
    ]),
  );
}

function summary_cards(scenario, loads) {
  let slots = $capacity.slots(scenario);
  let in_flight = $capacity.in_flight(scenario);
  let closest = $list.find_map(
    loads,
    (load) => {
      let _pipe = $capacity.peak_pct(load);
      let _pipe$1 = $option.map(_pipe, (pct) => { return [load, pct]; });
      return $option.to_result(_pipe$1, undefined);
    },
  );
  return $l.row(
    toList([$l.gap(16), $l.styles(toList([$css.flex_wrap("wrap")]))]),
    toList([]),
    toList([
      card(
        "Questions in flight",
        $int.to_string(in_flight),
        (() => {
          let $ = in_flight === slots;
          if ($) {
            return "Every message slot busy";
          } else {
            return ("Limited by volume, " + $int.to_string(slots)) + " slots";
          }
        })(),
      ),
      (() => {
        if (closest instanceof Ok) {
          let load = closest[0][0];
          let pct = closest[0][1];
          return card(
            "Closest to a limit",
            model_name(load.model_alias),
            pct_text(pct),
          );
        } else {
          return card("Closest to a limit", "–", "No model with known limits");
        }
      })(),
      (() => {
        if (closest instanceof Ok) {
          let pct = closest[0][1];
          if (pct > 0.0) {
            return card(
              "Room to grow",
              "×" + $float.to_string(
                $float.to_precision(divideFloat(100.0, pct), 1),
              ),
              "This load fits that many times before the limit",
            );
          } else {
            return card("Room to grow", "–", "No model with known limits");
          }
        } else {
          return card("Room to grow", "–", "No model with known limits");
        }
      })(),
      card(
        "Time per proposal",
        duration_text($capacity.seconds_per_proposal(scenario)),
        ((($int.to_string(
          scenario.proposals_in_parallel * scenario.questions_per_proposal,
        ) + " questions in ") + plural($capacity.waves(scenario), "wave")) + " of up to ") + $int.to_string(
          slots,
        ),
      ),
    ]),
  );
}

function number_field(title, source, value, on_change) {
  return $l.column(
    toList([$l.gap(4), $l.styles(toList([$css.width(px(220))]))]),
    toList([]),
    toList([
      $input.input(
        (() => {
          let _pipe = $input.value($int.to_string(value));
          let _pipe$1 = $input.label(_pipe, title);
          let _pipe$2 = $input.type_(_pipe$1, "text");
          let _pipe$3 = $input.small(_pipe$2);
          return $input.on_input(
            _pipe$3,
            (text) => {
              let $ = $int.parse(text);
              if (text === "") {
                return on_change(0);
              } else if ($ instanceof Ok) {
                let value$1 = $[0];
                return on_change($int.max(value$1, 0));
              } else {
                return undefined;
              }
            },
          );
        })(),
      ),
      $typography.text($typography.xs, $typography.regular, source),
    ]),
  );
}

function scenario_fields(
  scenario,
  questions_source,
  estimated_seconds,
  set_scenario,
  set_questions_per_proposal,
  set_seconds_per_question
) {
  return $l.row(
    toList([$l.gap(32), $l.styles(toList([$css.flex_wrap("wrap")]))]),
    toList([]),
    toList([
      $l.column(
        toList([$l.gap(12)]),
        toList([]),
        toList([
          $typography.text($typography.sm, $typography.medium, "Infrastructure"),
          $l.row(
            toList([$l.gap(16), $l.styles(toList([$css.flex_wrap("wrap")]))]),
            toList([]),
            toList([
              number_field(
                "Servers",
                "Nabu containers running, set in the infrastructure",
                scenario.servers,
                (servers) => {
                  return set_scenario(
                    new Scenario(
                      servers,
                      scenario.workers,
                      scenario.answer_messages,
                      scenario.proposals_in_parallel,
                      scenario.questions_per_proposal,
                      scenario.seconds_per_question,
                    ),
                  );
                },
              ),
              number_field(
                "Workers per server",
                "dockerfiles/nabu.dockerfile: --workers 4",
                scenario.workers,
                (workers) => {
                  return set_scenario(
                    new Scenario(
                      scenario.servers,
                      workers,
                      scenario.answer_messages,
                      scenario.proposals_in_parallel,
                      scenario.questions_per_proposal,
                      scenario.seconds_per_question,
                    ),
                  );
                },
              ),
              number_field(
                "Answer messages per worker",
                "nabu/main.py: nb_parallel_messages=6",
                scenario.answer_messages,
                (answer_messages) => {
                  return set_scenario(
                    new Scenario(
                      scenario.servers,
                      scenario.workers,
                      answer_messages,
                      scenario.proposals_in_parallel,
                      scenario.questions_per_proposal,
                      scenario.seconds_per_question,
                    ),
                  );
                },
              ),
            ]),
          ),
        ]),
      ),
      $l.column(
        toList([$l.gap(12)]),
        toList([]),
        toList([
          $typography.text($typography.sm, $typography.medium, "Volume"),
          $l.row(
            toList([$l.gap(16), $l.styles(toList([$css.flex_wrap("wrap")]))]),
            toList([]),
            toList([
              number_field(
                "Proposals in parallel",
                "Typed by hand: no data for it",
                scenario.proposals_in_parallel,
                (proposals_in_parallel) => {
                  return set_scenario(
                    new Scenario(
                      scenario.servers,
                      scenario.workers,
                      scenario.answer_messages,
                      proposals_in_parallel,
                      scenario.questions_per_proposal,
                      scenario.seconds_per_question,
                    ),
                  );
                },
              ),
              number_field(
                "Questions per proposal",
                questions_source,
                scenario.questions_per_proposal,
                set_questions_per_proposal,
              ),
            ]),
          ),
        ]),
      ),
      $l.column(
        toList([$l.gap(12)]),
        toList([]),
        toList([
          $typography.text(
            $typography.sm,
            $typography.medium,
            "Processing time",
          ),
          $callout.warning(
            toList([]),
            toList([
              $callout.content(
                toList([]),
                toList([
                  $l.column(
                    toList([$l.gap(8)]),
                    toList([]),
                    toList([
                      number_field(
                        "Seconds per question",
                        "Estimate: " + duration_text(estimated_seconds),
                        $float.round(scenario.seconds_per_question),
                        set_seconds_per_question,
                      ),
                      $typography.text(
                        $typography.xs,
                        $typography.regular,
                        ("Estimated from the Langfuse median latency of the steps " + "that answer a question, added up. To be improved by ") + "timing all the traces of each proposal.",
                      ),
                    ]),
                  ),
                ]),
              ),
            ]),
          ),
        ]),
      ),
    ]),
  );
}

function sort_by_peak(loads) {
  return $list.sort(
    loads,
    (a, b) => {
      let $ = $capacity.peak_pct(a);
      let $1 = $capacity.peak_pct(b);
      if ($ instanceof Some) {
        if ($1 instanceof Some) {
          let a$1 = $[0];
          let b$1 = $1[0];
          return $float.compare(b$1, a$1);
        } else {
          return new $order.Lt();
        }
      } else if ($1 instanceof Some) {
        return new $order.Gt();
      } else {
        return $float.compare(b.requests_per_minute, a.requests_per_minute);
      }
    },
  );
}

function use_fetch_usage(store, environment, days, dispatch) {
  return ((_capture) => {
    return $redraw.use_effect(_capture, [environment, days]);
  })(
    () => {
      let _pipe = $dict.get(store.llm_usage, [environment, days]);
      let _pipe$1 = $result.unwrap(_pipe, new $remote.NotLoaded());
      return $remote.load(
        _pipe$1,
        () => {
          dispatch(
            $llm_capacity_effects.fetch_llm_usage(environment, days, false),
          );
          return undefined;
        },
      );
    },
  );
}

export function view() {
  return $redraw.component_(
    "LlmCapacityCapacity",
    (_use0) => {
      let environment = _use0[0];
      let environment_picker = _use0[1];
      let store = $store.use_state();
      let dispatch = $store.use_effect_dispatch();
      let $ = $redraw.use_state(default_scenario);
      let scenario = $[0];
      let set_scenario = $[1];
      let $1 = $redraw.use_state(new None());
      let questions_per_proposal = $1[0];
      let set_questions_per_proposal = $1[1];
      let $2 = $redraw.use_state(new None());
      let seconds_per_question = $2[0];
      let set_seconds_per_question = $2[1];
      let $3 = $redraw.use_state(30);
      let days = $3[0];
      let set_days = $3[1];
      use_fetch_usage(store, environment, days, dispatch);
      let _block;
      let _pipe = $dict.get(store.llm_usage, [environment, days]);
      _block = $result.unwrap(_pipe, new $remote.NotLoaded());
      let usage$1 = _block;
      return $l.column(
        toList([$l.gap(24)]),
        toList([]),
        toList([
          $l.row(
            toList([$l.gap(12), $l.justify("flex-end"), $l.align("center")]),
            toList([]),
            toList([
              (() => {
                if (usage$1 instanceof $remote.Loaded) {
                  let usage$2 = usage$1[0];
                  return $typography.text(
                    $typography.sm,
                    $typography.regular,
                    "Updated " + $rate_limits.local_time_text(
                      usage$2.fetched_at,
                    ),
                  );
                } else {
                  return $h.none();
                }
              })(),
              $button.secondary(
                toList([
                  $a.disabled(usage$1 instanceof $remote.Loading),
                  $e.on_click(
                    (_) => {
                      dispatch(
                        $llm_capacity_effects.fetch_llm_usage(
                          environment,
                          days,
                          true,
                        ),
                      );
                      return undefined;
                    },
                  ),
                ]),
                toList([$h.text("Refresh")]),
              ),
              $segmented_button.segmented_button(
                (() => {
                  let _pipe$1 = $segmented_button.on_selected(set_days);
                  return $segmented_button.selected(_pipe$1, new Some(days));
                })(),
                $list.map(
                  windows_days,
                  (days) => {
                    return $segmented_button.choice(
                      ("Last " + $int.to_string(days)) + " days",
                      days,
                    );
                  },
                ),
              ),
              environment_picker,
            ]),
          ),
          (() => {
            let $4 = store.llm_rate_limits;
            if (usage$1 instanceof $remote.Errored) {
              let error = usage$1[0];
              return $callout.error(
                toList([]),
                toList([$callout.content(toList([]), toList([$h.text(error)]))]),
              );
            } else if (usage$1 instanceof $remote.Loaded) {
              if ($4 instanceof $remote.Errored) {
                let error = $4[0];
                return $callout.error(
                  toList([]),
                  toList([
                    $callout.content(toList([]), toList([$h.text(error)])),
                  ]),
                );
              } else if ($4 instanceof $remote.Loaded) {
                let usage$2 = usage$1[0];
                let deployments = $4[0];
                let $5 = $capacity.questions(usage$2);
                if ($5 === 0) {
                  return $typography.text(
                    $typography.sm,
                    $typography.regular,
                    ((("No question in Langfuse " + environment) + " over the last ") + $int.to_string(
                      days,
                    )) + " days, so there is no load to estimate.",
                  );
                } else {
                  let average_questions = $capacity.questions_per_proposal(
                    usage$2,
                  );
                  let estimated_seconds = $capacity.seconds_per_question(
                    usage$2,
                  );
                  let scenario$1 = new Scenario(
                    scenario.servers,
                    scenario.workers,
                    scenario.answer_messages,
                    scenario.proposals_in_parallel,
                    $option.unwrap(questions_per_proposal, average_questions),
                    $option.unwrap(seconds_per_question, estimated_seconds),
                  );
                  let _block$1;
                  let _pipe$1 = $capacity.model_loads(
                    scenario$1,
                    usage$2,
                    deployments,
                  );
                  _block$1 = sort_by_peak(_pipe$1);
                  let loads = _block$1;
                  return $l.column(
                    toList([$l.gap(24)]),
                    toList([]),
                    toList([
                      scenario_fields(
                        scenario$1,
                        ((("Langfuse " + environment) + ": ") + $int.to_string(
                          average_questions,
                        )) + " on average",
                        estimated_seconds,
                        set_scenario,
                        (value) => {
                          return set_questions_per_proposal(new Some(value));
                        },
                        (value) => {
                          return set_seconds_per_question(
                            new Some($int.to_float(value)),
                          );
                        },
                      ),
                      summary_cards(scenario$1, loads),
                      models_table(loads, deployments),
                      $typography.text(
                        $typography.xs,
                        $typography.regular,
                        (((((((("Every LLM call in Langfuse " + environment) + " over the last ") + $int.to_string(
                          days,
                        )) + " days counts on its model, scaled per question: calls ") + "outside the answer flow are assumed to grow with ") + "questions. Peak assumes every message slot is busy. A ") + "model with several deployments adds up their limits. ") + "Anthropic tokens show the tighter of its input and ") + "output limits.",
                      ),
                    ]),
                  );
                }
              } else {
                return $loader.loader(toList(["Loading the LLM usage…"]));
              }
            } else if ($4 instanceof $remote.Errored) {
              let error = $4[0];
              return $callout.error(
                toList([]),
                toList([$callout.content(toList([]), toList([$h.text(error)]))]),
              );
            } else {
              return $loader.loader(toList(["Loading the LLM usage…"]));
            }
          })(),
        ]),
      );
    },
  );
}
